import { render, staticRenderFns } from "./packagesReport.vue?vue&type=template&id=7ecb6fd0"
import script from "./packagesReport.vue?vue&type=script&lang=js"
export * from "./packagesReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports